import { ApiError } from './api.error';

export enum AuthErrorName {
  USER_NOT_CONFIRMED = 'UserNotConfirmedException',
  SESSION_EXPIRED = 'SessionExpiredException',
  INVALID_CREDENTIALS = 'InvalidCredentialsException',
  INSUFFICIENT_PERMISSIONS = 'InsufficientPermissionsException',
  BASE_AUTH_FAILED = 'AuthFailedException'
}

export class AuthError extends ApiError {
  /**
   * @constructor
   *
   * @param name
   * @param statusCode
   * @param details
   */
  constructor(name: AuthErrorName, statusCode?: number, details?: Record<string, unknown>) {
    super(name, name, statusCode, details);
  }

  /**
   * Try to create an `AuthError` from an `ApiError` by matching the error message
   * against the known AuthErrorName values.
   *
   * @param error The `ApiError` to attempt conversion from.
   *
   * @returns An `AuthError` if the message matches a known auth error name.
   */
  public static fromApiError(error: ApiError): AuthError {
    const knownNames = Object.values(AuthErrorName);

    const errorName = knownNames.find(name => error.message.includes(name));

    if (!errorName) {
      return new AuthError(AuthErrorName.BASE_AUTH_FAILED, error.statusCode, error.details);
    }

    return new AuthError(errorName, error.statusCode, error.details);
  }
}
